<template>
  <div class="shop-order-traffic-section">
    <section
      v-for="(traffic, index) in trafficList"
      :key="'traffic-' + index"
      class="order-card"
    >
      <div class="section-title">{{ getTrafficTitleFn(traffic.traffic_type, index) }}</div>
      <div class="form-grid">
        <div
          v-for="field in getVisibleTrafficFieldsFn(traffic.traffic_type)"
          :key="'traffic-field-' + index + '-' + field.key"
          class="form-item"
          :class="{ 'form-item--full': isWideFieldFn(field.key) }"
        >
          <label>{{ getFieldLabelFn(field.key, field.config) }}<span v-if="isRequiredFn(field.config)" class="required">*</span></label>

        <el-input
          v-if="getFieldModeFn(field.config, field.key) === 'text'"
          v-model.trim="traffic[field.key]"
          :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
        ></el-input>

        <el-input
          v-else-if="getFieldModeFn(field.config, field.key) === 'number'"
          v-model.trim="traffic[field.key]"
          type="number"
          :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
        ></el-input>

        <el-input
          v-else-if="getFieldModeFn(field.config, field.key) === 'textarea'"
          v-model.trim="traffic[field.key]"
          type="textarea"
          :rows="3"
          :placeholder="'请输入' + getFieldLabelFn(field.key, field.config)"
        ></el-input>

        <el-date-picker
          v-else-if="getFieldModeFn(field.config, field.key) === 'date'"
          v-model="traffic[field.key]"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="请选择日期"
          style="width: 100%;"
        ></el-date-picker>

        <el-select
          v-else-if="getFieldModeFn(field.config, field.key) === 'time' && hasTrafficTimeOptionsFn(traffic, field.key)"
          v-model="traffic[field.key]"
          filterable
          placeholder="请选择时间"
          @change="onTrafficFieldChangeFn(traffic, field.key)"
        >
          <el-option
            v-for="item in getTrafficTimeOptionsFn(traffic, field.key)"
            :key="'traffic-time-' + index + '-' + field.key + '-' + getOptionValueFn(item)"
            :label="getOptionLabelFn(item)"
            :value="getOptionValueFn(item)"
          />
        </el-select>

        <el-time-picker
          v-else-if="getFieldModeFn(field.config, field.key) === 'time'"
          v-model="traffic[field.key]"
          value-format="HH:mm:ss"
          placeholder="请选择时间"
          style="width: 100%;"
        ></el-time-picker>

        <el-switch
          v-else-if="getFieldModeFn(field.config, field.key) === 'boolean'"
          v-model="traffic[field.key]"
          :active-value="true"
          :inactive-value="false"
        ></el-switch>

        <el-select
          v-else
          v-model="traffic[field.key]"
          filterable
          placeholder="请选择"
          @change="onTrafficFieldChangeFn(traffic, field.key)"
        >
          <el-option
            v-for="item in getTrafficFieldOptionsFn(traffic, field.key, field.config)"
            :key="'traffic-opt-' + index + '-' + field.key + '-' + getOptionValueFn(item)"
            :label="getOptionLabelFn(item)"
            :value="getOptionValueFn(item)"
          />
        </el-select>
        </div>
      </div>

      <div
        v-if="traffic.traffic_type === 'voucher' && traffic.s_location && getSelectedVoucherLocationFn(traffic)"
        class="voucher-location-info"
      >
        <div class="voucher-info-row">
          <span class="voucher-info-label">地址</span>
          <span class="voucher-info-value">{{ getSelectedVoucherLocationFn(traffic).address || '-' }}</span>
        </div>
        <div class="voucher-info-row">
          <span class="voucher-info-label">营业时间</span>
          <div class="voucher-info-value">
            <div
              v-for="(timeInfo, timeIndex) in getVoucherLocationTimeLinesFn(getSelectedVoucherLocationFn(traffic))"
              :key="'voucher-time-' + index + '-' + timeIndex"
            >
              {{ timeInfo }}
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ShopOrderTrafficSection',
  props: {
    trafficList: { type: Array, required: true },
    getTrafficTitleFn: { type: Function, required: true },
    getVisibleTrafficFieldsFn: { type: Function, required: true },
    isWideFieldFn: { type: Function, required: true },
    getFieldLabelFn: { type: Function, required: true },
    isRequiredFn: { type: Function, required: true },
    getFieldModeFn: { type: Function, required: true },
    hasTrafficTimeOptionsFn: { type: Function, required: true },
    onTrafficFieldChangeFn: { type: Function, required: true },
    getTrafficTimeOptionsFn: { type: Function, required: true },
    getOptionValueFn: { type: Function, required: true },
    getOptionLabelFn: { type: Function, required: true },
    getTrafficFieldOptionsFn: { type: Function, required: true },
    getSelectedVoucherLocationFn: { type: Function, required: true },
    getVoucherLocationTimeLinesFn: { type: Function, required: true },
  },
};
</script>

<style scoped>
@import './shopOrderSection.css';
</style>



// WEBPACK FOOTER //
// src/pages/shop/components/ShopOrderTrafficSection.vue